// extracted by mini-css-extract-plugin
export default {"error":"ValidationError_error__3Sut+","errorText":"ValidationError_errorText__mJFXM"};